import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { ModalController, IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonTitle, IonToolbar } from '@ionic/angular';
import { AuswahlPage } from '../auswahl/auswahl.page';
import { dayjs } from '@afs-ng/core';
import { FeedbackService, MsgType } from '../../services/feedback.service';
import { GlobalSettingsService } from '../../services/global-settings.service';
import { HttpService, HttpFunctionResult } from '../../services/http.service';
import { State } from '../../services/status.service';
import { StempelService } from '../../services/stempel.service';
import { UserWithState } from '../../services/terminal.service';
import { CommonModule, NgStyle } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AFSToastLoadingService } from '@afs-ng/overlays';

@Component({
    selector: 'app-stempel',
    templateUrl: './stempel.page.html',
    styleUrls: ['./stempel.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonTitle, IonToolbar, NgStyle, CommonModule, FormsModule]
})
export class StempelPage {
  private feedback = inject(FeedbackService);
  http = inject(HttpService);
  stempSrv = inject(StempelService);
  private modalCrtl = inject(ModalController);
  private settings = inject(GlobalSettingsService);
  private toastLoading = inject(AFSToastLoadingService);


  btnTitle: string = 'Kommen';
  pauseTitle: string = 'Pause';
  isPaused: boolean = false;
  isAbsent: boolean = true;
  isWorking: boolean = false;
  public loaded: boolean = false

  public fontSize: number = null

  public stateTimer: any = null

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
      this.checkUser()
  }

  async ngOnInit(){
    this.fontSize = await this.settings.getStatus()
    this.initStateTimer()
  }

  private initStateTimer(){
    if(!this.settings.autoStamp) return
    // if(!this.stempSrv.fromNFC || !this.http.serverVersionGreaterThan('1.1.0'))
    this.stateTimer = setTimeout(async () => {
      if(this.isWorking) await this.setState(-1)
      else await this.setState(0)
    }, 30000);
  }

  ngOnDestroy(){
    this.stempSrv.fromNFC = false
    clearTimeout(this.stateTimer)
  }

  private checkUser() {
    this.isAbsent = this.stempSrv.currentUser.closed == 1 || !this.stempSrv.activeState || !(this.stempSrv.currentUser.state === 0 || this.stempSrv.activeState.mobile);
    this.isPaused = !this.isAbsent && this.stempSrv.currentUser.state === 1;
    this.isWorking = !this.isAbsent && this.stempSrv.currentUser.state === 0;
    if (this.isWorking) this.btnTitle = 'Gehen';
    else if (!this.isAbsent) this.btnTitle = 'Arbeiten';
    else this.btnTitle = 'Kommen';
  };


  public async setState(state: number) {
    const result: HttpFunctionResult<any> = await this.toastLoading.showLoading(
      {title: "Status setzen..."},
      () => this.stempSrv.setNewUserState({userId: this.stempSrv.currentUser.userId, state: state})
    )
    if(result.success) await this.cancel(state)
  }


  async choose() {
    clearTimeout(this.stateTimer)
    await this.feedback.openModal<State>(AuswahlPage, {}, async (result: HttpFunctionResult<State>)=>{
      if(!result.success) return
      await this.setState(result.data.id) 
    }, true, "md")
  }

  async cancel(state: number = null) {
    if(state != null){
      var newUser: UserWithState = Object.assign({}, this.stempSrv.currentUser)
      newUser.state = state
      newUser.closed = state == -1 ? 1 : 0
      await this.modalCrtl.dismiss(newUser)
    } else await this.modalCrtl.dismiss()
  }

  public async showWorkTime(){
    const result: HttpFunctionResult<{workingtime: number}> = await this.toastLoading.showLoading(
      {title: "Arbeitszeit wird berechnet..."},
      () => this.http.GET<{workingtime: number}>({path: `user/worktime/${this.stempSrv.currentUser.userId}`})
    )
    if(result.success) await this.feedback.showMsg(MsgType.Info, `Heutige Arbeitszeit: ${dayjs.utc(result.data?.workingtime * 1000 ).format("HH:mm")} Std.`)
  }


}
